import {useEffect, useRef, useState} from 'react';

export function useStickyGraph(stickyEnabled = true, graphHeight, options = {}) {
  const graphRef = useRef(null);
  const internalRef = useRef({
    lastWidth: null,
    frameId: null,
    timeoutId: null,
  });
  const [width, setWidth] = useState(null);
  const [shouldStick, setShouldStick] = useState(false);

  useEffect(() => {
    const element = graphRef.current;
    if (!element) return;

    const intersectionObserver = new IntersectionObserver(([entry]) => {
      //  const viewportHeight = window.innerHeight;
      //  const minViewportHeight = graphHeight * 1.25;

      const newShouldStick =
        !entry.isIntersecting && entry.boundingClientRect.bottom < graphHeight && stickyEnabled;

      setShouldStick(newShouldStick);
    }, options);

    const resizeObserver = new ResizeObserver(entries => {
      const entry = entries[0];
      if (!entry) return;

      const {frameId, timeoutId} = internalRef.current;
      if (frameId) cancelAnimationFrame(frameId);
      if (timeoutId) clearTimeout(timeoutId);

      internalRef.current.frameId = requestAnimationFrame(() => {
        internalRef.current.timeoutId = setTimeout(() => {
          const newWidth = Math.round(entry.contentRect.width);
          if (internalRef.current.lastWidth !== newWidth) {
            internalRef.current.lastWidth = newWidth;
            setWidth(newWidth);
          }
        }, 0);
      });
    });

    intersectionObserver.observe(element);
    resizeObserver.observe(element);

    return () => {
      intersectionObserver.disconnect();
      resizeObserver.disconnect();
      const {frameId, timeoutId} = internalRef.current;
      if (frameId) cancelAnimationFrame(frameId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [options, stickyEnabled, graphHeight]);

  return [graphRef, shouldStick, width];
}

export default useStickyGraph;
